/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var CustomJournalColumnName;
(function (CustomJournalColumnName) {
    CustomJournalColumnName["ACCOUNT_ENTITY_ID"] = "Account Entity ID";
    CustomJournalColumnName["ACCOUNT_ENTITY_TYPE"] = "Account Entity Type";
    CustomJournalColumnName["SUBSIDIARY"] = "Subsidiary";
    CustomJournalColumnName["JOURNAL"] = "Journal";
    CustomJournalColumnName["DEPARTMENT"] = "Department";
})(CustomJournalColumnName || (CustomJournalColumnName = {}));
